import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { initLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ValueProp from "@/components/ValueProp";
import Resume from "@/components/Resume";
import Capabilities from "@/components/Capabilities";
import FeaturedBuild from "@/components/FeaturedBuild";
import Faq from "@/components/Faq";
import LeadForm from "@/components/LeadForm";
import ServicesPage from "@/pages/ServicesPage";
import ScrollToTop from "@/components/ScrollToTop";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.failed) {
      return (
        <div className="min-h-screen bg-[#0B0F17] text-[#9CA3AF] flex items-center justify-center p-8">
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <ValueProp />
      <Resume />
      <Capabilities />
      <FeaturedBuild />
      <Faq />
      <LeadForm />
    </>
  );
}

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <BrowserRouter>
      <div className="bg-[#0B0F17] text-[#F9FAFB] min-h-screen overflow-x-clip antialiased">
        <a href="#main-content" data-testid="skip-to-content-link" className="skip-link">
          Skip to content
        </a>
        <div className="grain-overlay" aria-hidden="true" />
        <ErrorBoundary>
          <MotionConfig reducedMotion="user">
            <ScrollToTop />
            <Navbar />
            <main id="main-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </MotionConfig>
        </ErrorBoundary>
      </div>
    </BrowserRouter>
  );
}

export default App;
